import {useState } from 'react'; 
import {Link} from 'react-router-dom'
import { Helmet } from "react-helmet-async";
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import Slider from '../../components/Slider';
import DragupButton from '../../components/DragupButton';
function Home() {
  return (
    <>
    <Helmet>
        <title>Startseite | Elektro Thome</title>
        <meta name="description" content="Elektro Thome – Ihr Partner für Photovoltaik, Lade­stationen und Elektroinstallationen im Saarland. Jetzt beraten lassen!" />
        <link rel="canonical" href="https://energy-thome.com/" />
    </Helmet>
    <DragupButton></DragupButton>
    <Navbar></Navbar>
      <Slider></Slider>
      <Footer></Footer></>
  );
}

export default Home;
